import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { GrowingSpacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import styled from "styled-components";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { FaireDirectBrandPreviewBanner } from "@faire/retailer/views/faire-direct/components/FaireDirectBrandPreviewBanner";
import { SignIn } from "@faire/retailer/views/faire-direct/components/SignIn";
export var PageWrapper = function(param) {
    var showBorder = param.showBorder, children = param.children, loginUrl = param.loginUrl, isPreSample = param.isPreSample;
    var isMobile = useViewport().isMobile;
    var shouldHideSignIn = isPreSample || isMobile || getIsBrandPreview();
    return /*#__PURE__*/ _jsxs(PageContainer, {
        children: [
            shouldHideSignIn ? null : /*#__PURE__*/ _jsxs(RightRow, {
                children: [
                    /*#__PURE__*/ _jsx(GrowingSpacer, {}),
                    /*#__PURE__*/ _jsx(SignIn, {
                        loginUrl: loginUrl,
                        eventPath: "elevate-sign-up/landing-page/click/log-in"
                    })
                ]
            }),
            getIsBrandPreview() ? /*#__PURE__*/ _jsx(FaireDirectBrandPreviewBanner, {}) : null,
            showBorder ? /*#__PURE__*/ _jsx(Border, {}) : null,
            children
        ]
    });
};
var PageContainer = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-92a3690c-0"
})([
    "width:100%;min-height:95vh;"
]);
var Border = styled.div.withConfig({
    componentId: "sc-92a3690c-1"
})([
    "width:calc(100% - 70px);height:1px;background-color:",
    ";"
], Core.surface.subdued);
var RightRow = styled(Row).withConfig({
    componentId: "sc-92a3690c-2"
})([
    "width:100%;padding:20px;background:#f9f5f0;margin-left:auto;"
]);
